import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import { bulkWinesService } from '../services/bulk-wines.service';
import type { BulkWinesListResponse } from '../services/bulk-wines.service';
import { getQueryState, type QueryWithState } from './useQueryWithState';

export const useBulkWines = (params: URLSearchParams): QueryWithState<BulkWinesListResponse> => {
  const query = useQuery({
    queryKey: ['bulk-wines', params.toString()],
    queryFn: () => bulkWinesService.getList(params),
    placeholderData: keepPreviousData,
  });

  return {
    ...query,
    renderState: getQueryState(query, (data) => data.data.length === 0),
  };
};

export const useBulkWine = (id: string | number, enabled = true): QueryWithState<unknown> => {
  const query = useQuery({
    queryKey: ['bulk-wines', id],
    queryFn: () => bulkWinesService.getById(id),
    enabled,
  });

  return {
    ...query,
    renderState: getQueryState(query),
  };
};

export const useSaveBulkWine = () =>
  {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: ({ id, payload }: { id: string | number | null; payload: Record<string, unknown> }) =>
        bulkWinesService.save(id, payload),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['bulk-wines'] });
      },
    });
  };

export const useDeleteBulkWine = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string | number) => bulkWinesService.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bulk-wines'] });
    },
  });
};
